module.exports = __webpack_public_path__ + "static/media/Hash.6cb049eb.svg";